import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const StyledPlot = styled(Box)({
  width: '100%',
  height: '100%',
})
